import { render, staticRenderFns } from "./testimonial-list.vue?vue&type=template&id=5601b138&"
import script from "./testimonial-list.vue?vue&type=script&lang=js&"
export * from "./testimonial-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports